__turbopack_context__.v({
  "actions": "DesignLibraryTeaser-module-scss-module__UVyv-G__actions",
  "author": "DesignLibraryTeaser-module-scss-module__UVyv-G__author",
  "card": "DesignLibraryTeaser-module-scss-module__UVyv-G__card",
  "container": "DesignLibraryTeaser-module-scss-module__UVyv-G__container",
  "content": "DesignLibraryTeaser-module-scss-module__UVyv-G__content",
  "description": "DesignLibraryTeaser-module-scss-module__UVyv-G__description",
  "image": "DesignLibraryTeaser-module-scss-module__UVyv-G__image",
  "indicators": "DesignLibraryTeaser-module-scss-module__UVyv-G__indicators",
  "inner": "DesignLibraryTeaser-module-scss-module__UVyv-G__inner",
  "main": "DesignLibraryTeaser-module-scss-module__UVyv-G__main",
  "publishedStatus": "DesignLibraryTeaser-module-scss-module__UVyv-G__publishedStatus",
  "saveButton": "DesignLibraryTeaser-module-scss-module__UVyv-G__saveButton",
  "secondary": "DesignLibraryTeaser-module-scss-module__UVyv-G__secondary",
  "spoiler": "DesignLibraryTeaser-module-scss-module__UVyv-G__spoiler",
  "tag": "DesignLibraryTeaser-module-scss-module__UVyv-G__tag",
  "tags": "DesignLibraryTeaser-module-scss-module__UVyv-G__tags",
  "thumbnail": "DesignLibraryTeaser-module-scss-module__UVyv-G__thumbnail",
  "title": "DesignLibraryTeaser-module-scss-module__UVyv-G__title",
});
